<template>
  <div>
    <van-overlay :show="isLoading" zIndex="2">
      <van-loading color="#1989fa" size="64" class="txt-c" />
    </van-overlay>

    <van-nav-bar :title="titlePage" :border="false">
      <template #right>
        <router-link tag="div" to="/setting" class="page-title-btn">
          <img src="@/assets/images/settings.svg" alt="" srcset="" />
        </router-link>
      </template>
    </van-nav-bar>

    <div
      class="task-list"
      :class="{
        bottomSpace: !bottomSpace,
      }"
    >
      <template v-if="tasksList.length">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text=""
          :loading-text="$t('btn.loading')"
          @load="onLoad"
        >
          <div
            class="task-list-item"
            v-for="(item, key) in tasksList"
            :key="key"
          >
            <div class="task-list-item__link" @click="doTo(item)">
              <p class="task-list-item__text">
                {{ getHortText(item.text) }}
              </p>

              <div v-if="item.attachments">
                <van-image
                  width="96"
                  height="96"
                  fit="contain"
                  v-for="(elem, key) in item.attachments"
                  :key="key"
                  :src="elem"
                  @click="show = true"
                />
              </div>
            </div>
            <div class="btn-row" tabindex="2" v-if="item.id_category == 0">
              <van-button type="primary" tabindex="3" @click="accept(item)">
                {{ $t("btn.accept") }}
              </van-button>

              <van-button
                plain
                type="primary"
                tabindex="4"
                @click="deleteTask(item)"
              >
                {{ $t("btn.delete") }}
              </van-button>
            </div>
          </div>
        </van-list>
      </template>
      <van-empty description="" v-else />
    </div>

    <van-button
      type="warning"
      class="btn more-btn"
      v-if="bottomSpace && params.type == 'new'"
      @click="showComplite()"
    >
      {{ $t("btn.complited", { count: choosenCategory.tasks_done }) }}
    </van-button>
    <van-button
      type="warning"
      class="btn more-btn"
      v-if="bottomSpace && params.type != 'new'"
      @click="showNew()"
    >
      {{ $t("btn.new_task", { count: choosenCategory.tasks }) }}
    </van-button>

    <div class="bottom-bar">
      <!-- <div class="bottom-bar-avatar">
        <van-image
          round
          width="46"
          height="46"
          src="@/assets/images/Avatars.png"
        />
      </div> -->
      <div class="bottom-bar-category-list">
        <div
          class="bottom-bar-category-list__item"
          :class="{
            active: choosenCategory.id == item.id,
          }"
          v-for="(item, key) in categoryList"
          :key="key"
          @click="getTasksByCategory(item)"
        >
          {{ item.title }}
        </div>
      </div>
    </div>

    <CatagoryCreate :isCreate="isCreate" @close="getListTask()" />

    <van-popup v-model="isChooseCategory" position="bottom">
      <ChooseCategory
        v-if="isChooseCategory"
        :isCategory="isChooseCategory"
        :task_id="choosenTask.id"
        @close="setCategory()"
      />
    </van-popup>

    <van-popup v-model="showPopover" position="bottom">
      <Task @closePopup="showPopover = false" :is-modal="true" />
    </van-popup>
  </div>
</template>

<script>
import ApiCategory from "@/api/category";
import ApiTasks from "@/api/tasks";

import { mapActions } from "vuex";
import CatagoryCreate from "@/components/Category/Create";
import ChooseCategory from "@/components/Task/ChooseCategory";
import Task from "@/views/Task";
import { eventBus } from "@/main";
import _ from "lodash";
export default {
  data() {
    return {
      showPopover: false,

      isLoading: true,
      isChooseCategory: false,
      isCreate: false,
      loading: false,
      finished: false,
      active: 0,
      categoryList: [],
      tasksList: [],
      choosenCategory: {},
      choosenTask: {},
      params: {
        limit: 10,
        offset: 0,
        id_category: 0,
        type: "new",
      },
    };
  },
  components: {
    CatagoryCreate,
    ChooseCategory,
    Task,
  },
  computed: {
    bottomSpace() {
      return (
        this.choosenCategory.id != 0 && this.choosenCategory.tasks_done != 0
      );
    },
    titlePage() {
      return this.choosenCategory.id == 0
        ? `${this.choosenCategory.title} (${this.choosenCategory.tasks})`
        : this.choosenCategory.title;
    },
  },
  methods: {
    ...mapActions("Task", ["setTask"]),

    showNew() {
      this.params.limit = 10;
      this.getListTask("new");
    },
    showComplite() {
      if (this.choosenCategory.tasks_done != 0) {
        this.params.limit = 10;
        this.getListTask("done");
      }
    },
    getHortText(text) {
      return text.length > 100 ? text.slice(0, 100) + "..." : text;
    },
    onLoad() {
      this.params.limit += 10;
      ApiTasks.getTasksByCategory(this.params).then((responce) => {
        this.tasksList = responce.data;
        this.loading = false;
        if (this.params.type == "new") {
          if (responce.data.length == this.choosenCategory.tasks) {
            this.finished = true;
          }
        } else {
          if (responce.data.length == this.choosenCategory.tasks_done) {
            this.finished = true;
          }
        }
      });
    },
    getListTask(type = "new") {
      this.params.type = type;
      this.isLoading = true;
      ApiTasks.getTasksByCategory(this.params).then((responce) => {
        this.tasksList = responce.data;
        this.finished = false;
        this.isLoading = false;
      });
    },
    getTasksByCategory(item) {
      this.params.id_category = item.id;
      this.choosenCategory = item;
      this.getListTask();
    },
    doTo(item) {
      console.log(item);

      this.setTask(item).then(() => {
        this.showPopover = true;
      });
    },
    setCategory() {
      this.isChooseCategory = false;
      this.getData();
    },
    accept(item) {
      if (this.categoryList.length > 1) {
        this.choosenTask = item;
        this.isChooseCategory = true;
      } else {
        this.isCreate = true;
      }
    },
    deleteTask(item) {
      this.$dialog
        .confirm({
          cancelButtonText: this.$t("category.no"),
          confirmButtonText: this.$t("category.yes"),
          closeOnClickOverlay: true,
          message: this.$t("category.confirm_delete"),
        })
        .then(() => {
          ApiTasks.deleteTask(item.id).then(() => {
            this.getData();
          });
        });
    },
    getData() {
      ApiCategory.getCategoryList().then((responce) => {
        this.categoryList = responce.data;
        let id = this.choosenCategory.id;
        let cat = _.find(responce.data, (item) => {
          return item.id == id;
        });
        if (cat) {
          this.choosenCategory = cat;
        } else {
          this.choosenCategory = responce.data[0];
        }

        this.getListTask();
      });
    },
  },
  mounted() {
    eventBus.$on("doneTask", () => {
      this.getData();
      this.showPopover = false;
    });

    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.task-list {
  .task-list-item {
    padding: 16px;
    background: #f9f8f9;
    border-radius: 12px;
    margin-bottom: 20px;
    cursor: pointer;
    display: block;
    color: #111;
    &__text {
      font-weight: 300;
      font-size: 16px;
      line-height: 19px;
      margin-bottom: 12px;
    }
  }
}

.more-btn {
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
}
.more-btn,
.bottomSpace {
  margin-bottom: 82px;
}

.bottom-bar {
  display: flex;
  align-items: center;
  height: 72px;
  background: #ffffff;
  border-radius: 8px 8px 0px 0px;
  box-shadow: 0px 5px 25px rgba(0, 0, 0, 0.12);
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 13px 16px;
  width: 100%;
  &-avatar {
    margin-right: 9px;
  }
  &-category-list {
    max-width: calc(100% - 9px);
    // max-width: calc(100% - 48px - 9px);
    width: 100%;
    display: flex;
    align-items: center;
    overflow-x: auto;
    &::-webkit-scrollbar {
      width: 0;
      display: none;
    }
    &__item {
      font-size: 16px;
      line-height: 19px;
      padding: 8px 16px;
      font-weight: 400;
      text-align: center;
      color: #9e9e9e;

      border: 1px solid #9e9e9e;
      border-radius: 6px;
      margin-right: 8px;
      cursor: pointer;

      &:hover {
        border-color: #111;
        color: #111;
      }
      &.active {
        font-weight: 500;
        background: #111111;
        border-color: #111;
        color: #ffffff;
      }
    }
  }
}
</style>
